var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{attrs:{"sitekey":"6LflB7IZAAAAAINQQDlPOKfDG7MYWLLO8W8EQKqM","loadRecaptchaScript":true},on:{"verify":_vm.validate,"expired":_vm.expireRecaptcha}})}
var staticRenderFns = []

export { render, staticRenderFns }